angular.module('mtic.components.login').constant('IAM_CODES', {
  LANG: {
    'TEACHER': 8165,
    'STUDENT': 8166,
    'RETURNING': 8171
  }
})
